import { locale } from "../../../utilities/locale/locale";
import CategoryService from "../../../service/CategoryService";
import SubcategoriesService from "../../../service/SubcategoriesService";
import { expectCode } from "../hooks/useAdminList";
import { getToken, normalizeText } from "./adminUtils";

// Campos de descrição traduzida usados por categorias, subcategorias e tipos
export const LANGUAGE_FIELDS = [
  { lang: "pt", field: "descriptionPortuguese", labelKey: "descriptionPT" },
  { lang: "en", field: "descriptionEnglish", labelKey: "descriptionEN" },
  { lang: "it", field: "descriptionItalian", labelKey: "descriptionIT" },
  { lang: "es", field: "descriptionSpanish", labelKey: "descriptionES" },
];

const FIELD_BY_LOCALE = {
  pt: "descriptionPortuguese",
  it: "descriptionItalian",
  es: "descriptionSpanish",
  en: "descriptionEnglish",
};

// Descrição no idioma atual do app, caindo para inglês (mesma regra do admin clássico)
export const localizedDescription = (item) =>
  item?.[FIELD_BY_LOCALE[locale] || "descriptionEnglish"] || item?.descriptionEnglish || "";

// Outras traduções, para exibir abaixo do nome principal
export const otherTranslations = (item) =>
  LANGUAGE_FIELDS.filter(({ field }) => field !== (FIELD_BY_LOCALE[locale] || "descriptionEnglish"))
    .map(({ lang, field }) => (item?.[field] ? `${lang.toUpperCase()}: ${item[field]}` : null))
    .filter(Boolean)
    .join(" · ");

export const translationsSearchText = (item) =>
  normalizeText(LANGUAGE_FIELDS.map(({ field }) => item?.[field]).filter(Boolean).join(" "));

export const emptyTranslations = () =>
  Object.fromEntries(LANGUAGE_FIELDS.map(({ field }) => [field, ""]));

export const pickTranslations = (item) =>
  Object.fromEntries(LANGUAGE_FIELDS.map(({ field }) => [field, item?.[field] || ""]));

export const missingTranslations = (values) =>
  LANGUAGE_FIELDS.filter(({ field }) => !values[field]?.trim());

// Mesmo endpoint de upload usado pelos formulários do admin clássico; devolve o imageid
export const uploadCatalogImage = async (file) => {
  const res = await new CategoryService().postUploadImage(getToken(), file);
  return expectCode(res, 200000).result;
};

// Vincula uma marca ou tipo a várias subcategorias (mesmos endpoints do admin clássico).
// Devolve quantos vínculos falharam, sem interromper os demais.
export const linkToSubcategories = async (kind, id, subcategoryIds) => {
  const service = new SubcategoriesService();
  const link =
    kind === "brand"
      ? (subId) => service.postLinkBrandSubcategory(getToken(), id, subId)
      : (subId) => service.postLinkTypeSubcategory(getToken(), id, subId);

  const results = await Promise.allSettled(
    subcategoryIds.map(async (subId) => expectCode(await link(subId), 200000)),
  );
  return results.filter((result) => result.status === "rejected").length;
};

// Depois de cadastrar, a API não devolve o id: busca pelo nome, como no admin clássico,
// ficando com o maior id em caso de nomes repetidos (o registro mais recente)
export const findNewestIdBy = (list, predicate) =>
  (list || []).filter(predicate).reduce((max, item) => (max == null || item.id > max ? item.id : max), null);

export const subcategoryOptions = (subcategories) =>
  (subcategories || [])
    .map((sub) => ({ id: sub.id, label: localizedDescription(sub) }))
    .sort((a, b) => a.label.localeCompare(b.label));

// Remove o erro dos campos que já foram preenchidos
export const clearFilled = (values) =>
  Object.fromEntries(
    Object.entries(values)
      .filter(([, value]) => typeof value === "string" && value.trim())
      .map(([field]) => [field, null]),
  );

export const MAX_IMAGE_MB = 1;
